import { render, staticRenderFns } from "./ResPreview.vue?vue&type=template&id=1e62d0e6&scoped=true&"
import script from "./ResPreview.vue?vue&type=script&lang=js&"
export * from "./ResPreview.vue?vue&type=script&lang=js&"
import style0 from "./ResPreview.vue?vue&type=style&index=0&id=1e62d0e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e62d0e6",
  null
  
)

export default component.exports